import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const CentreMasterMappingDeleteSlice = createSlice({
  name: "CentreMasterMappingDeleteSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    centreMasterMappingDelete: (state, _) => {
      state.isLoading = true;
    },
    successCentreMasterMappingDelete: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterMappingDelete: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterMappingDelete: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterMappingDelete,
  successCentreMasterMappingDelete,
  failureCentreMasterMappingDelete,
  clearCentreMasterMappingDelete,
} = CentreMasterMappingDeleteSlice.actions;

export default CentreMasterMappingDeleteSlice.reducer;
